import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Confirmation from './Confirmation';
import Form from './Form';
import Congratulations from './Congratulations';
import Finish from './Finish';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';

EventCloseDialog.propTypes = {
  event: PropTypes.object.isRequired
};

export default function EventCloseDialog(props) {
  const { event } = props;

  const { history } = usePageRouter();

  const [data, setData] = useState({
    completed: event.data.completed,
    cancelled: event.data.cancelled,
    cancelledMessage: event.data.cancelledMessage
  });
  const [showErrors, setShowErrors] = useState(false);
  const [step, setStep] = useState(1);

  const mutation = useQueryMutation('event.update', event);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onCancel();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data, {
      // onSuccess: payload => event._update(payload)
    });
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;

    if (name === 'completed' && value === true) {
      nextData.cancelled = false;
      nextData.cancelledMessage = '';
    }

    if (name === 'cancelled' && value === true) {
      nextData.completed = false;
    }

    setData(nextData);
  }

  function redirectToEvaluation(evaluation) {
    props.onCancel();
    history.push(`/evaluation-event-educator/${evaluation.id}`);
  }

  return (
    <DialogTemplate className="w-screen max-w-md">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={data.cancelled ? {
          cancelledMessage: [validators.isRequired]
        } : {}}>
          {({errors, hasError}) => {
            if (step === 3) {
              return (
                <Finish
                  event={event}
                  onCancel={props.onCancel}
                  onPrevious={() => setStep(1)}
                  onNext={redirectToEvaluation}
                />
              );
            }

            if (success) {
              return event.data.completed ? (
                <Congratulations
                  event={event}
                  onCancel={props.onCancel}
                  onPrevious={() => mutation.reset()}
                  onNext={() => setStep(3)}
                />
              ) : (
                <Confirmation
                  event={event}
                  onCancel={props.onCancel}
                  onPrevious={() => mutation.reset()}
                />
              );
            }

            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
                onCancel={props.onCancel}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Idea created.
                  </SuccessMessage>
                ) : null}
                event={event}
              />
            )
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
